import React, { Component } from 'react';
import { Row, Col } from 'react-grid-system';

import { I18n } from 'components/translate';
import { UserManagerService } from 'modules/userManager';
import UserReasonBlockModal from 'modules/userManager/usersList/actions/components/UserReasonBlockModal';
import UsersSingleActions from 'modules/userManager/usersList/actions/UsersSingleActions';
import PropTypes from 'prop-types';

import { changeStatus } from '../usersList/actions/helpers/changeStatus';
import { handleError } from '../usersList/actions/helpers/handleError';

export default class UserDetailPlusAccess extends Component {
  static propTypes = {
    userData: PropTypes.object.isRequired,
    onUpdate: PropTypes.func.isRequired,
    activeLabel: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.updateChangeStatus = this.updateChangeStatus.bind(this);
  }

  state = {
    isReasonBlockModalOpen: false
  };

  userSingleActionsRef = React.createRef();

  toggleUserReasonBlockModal = (open = null) => {
    this.setState((prevState) => ({
      isReasonBlockModalOpen:
        open !== null ? open : !prevState.isReasonBlockModalOpen
    }));
  };

  async updateChangeStatus(form) {
    const { onUpdate } = this.props;

    await changeStatus(form, onUpdate);
    this.toggleUserReasonBlockModal(false);
  }

  render() {
    const { userData, onUpdate, activeLabel, onClick } = this.props;
    const { isReasonBlockModalOpen } = this.state;
    const current = this.userSingleActionsRef?.current;

    return (
      <>
        <Col xs={12} sm={2.4}>
          <Row justify="between">
            <label className="class__select__label access__title">
              <I18n html label="general.access" />
            </label>
            <div className="user__single__actions">
              <UsersSingleActions
                ref={this.userSingleActionsRef}
                user={userData}
                onUpdate={onUpdate}
                toggleUserReasonBlockModal={this.toggleUserReasonBlockModal}
              />
            </div>
          </Row>

          <div className="blocked__label">
            {activeLabel && <I18n html label={activeLabel} />}
          </div>

          {UserManagerService.hasPlusAccess(userData.userPlusAccess) && (
            <Row justify="between">
              <div>
                <div className="plus__access">{'Plus'}</div>
              </div>
              <label className="view__more__label" onClick={onClick}>
                <I18n label="general.view_more" />
              </label>
            </Row>
          )}
        </Col>
        {current && isReasonBlockModalOpen && (
          <UserReasonBlockModal
            isOpen={isReasonBlockModalOpen}
            handleError={handleError}
            toggleModal={current?.toggleReasonBlockModal}
            changeStatus={this.updateChangeStatus}
          />
        )}
      </>
    );
  }
}
